import Vue from 'vue'

//region 过滤器
Vue.filter('formatDay', function (value) {
    return new Date(value).format("yyyy-MM-dd");
})
//endregion


// WEBPACK FOOTER //
// ./src/filter/index.js